import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class Slider {
  static init (idSlider) {
    const hasSlider = _checkSliderExists(idSlider)

    if (hasSlider) {
      const swiper = new Swiper(`#${idSlider}`, {
        modules: [Navigation],
        loop: true,
        autoplay: true,
        sliderPerView: 1,
        spaceBetween: 30,
        centeredSlidesBounds: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1024: {
            sliderPerView: 3
          },

          1280: {
            sliderPerView: 4
          }
        },
      })

      swiper.init()
    }
  }
}

const _checkSliderExists = (idSlider) => (document.getElementById(idSlider) !== null)

export default Slider